import FxeQuiz from "./fxe";
import MarginQuiz from "./margin";

"use strict";
{
    var app = angular.module("tf.quiz", [FxeQuiz, MarginQuiz])
                     .controller("quizCtrl", ["$scope", "$state", "helperService", "$http", function quizController($scope, $state, helperService, $http) {

                         $scope.mode = "quiz";

                         $scope.quizComplete = function (results) {
                             $scope.results = results;
                             $scope.mode = "result";
                         };

                         $scope.returnToHome = () => $state.go("home");

                         $scope.reset = () => {
                             $scope.mode = "quiz";
                             $scope.results = null;
                         }
                     }])
}

